import React, { Component } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { fetchWorkdays } from "../actions/index";
import * as constants from "../const";
import { showModalAction, getWorkdayAction } from "../actions/index";
import moment from "moment";

class CertifiedEmployeesWorkday extends React.Component {
  constructor(props) {
    super(props);
  }

  // show certified employee details
  showModal(modalObj) {
    this.props.onShowModal(modalObj.modalName); // toggling the modal popup
    var route = localStorage.getItem("route"),
        category = route,
        workdayDate = moment(modalObj.workdayDate, 'MM/DD/YYYY')
        workdayDate = workdayDate.format('YYYYMMDD');
    let role = this.props.role;
    this.props.getWorkday( // getting workday/duty_activities for that particular day
      constants.actionUrls.WORKDAY_URL + "/" + role + "/" + modalObj.workdayId + "/" + modalObj.certifyStatus
      + "/" + modalObj.empId + "/" + workdayDate + "/" + modalObj.dutyActivityStatus
    );
  }

  filterComments(string, target="^-", replacement=""){
      var i = 0, length = string.length;
      for (i; i < length; i++) {
        string = string.replace(target, replacement);
      }
      return string;
  };

  render() {
    var workday = this.props.workday;
    var full_name = workday.emp_full_name.split(" "),
        first_name = full_name[1],
        last_name = full_name[0],
        workday_time = workday.wdy_working_time_hos.split("h"),
        checkFortime = parseFloat(
          workday_time[0] * 60 +
            parseFloat(workday_time[1] == "" ? 0 : workday_time[1])
        ), wdy_time_condition = constants.checkAgainst, workday_comment = '';
    if(workday.wdy_comments && workday.wdy_comments != null){

      var comments = this.filterComments(workday.wdy_comments.trim());
      var comment = comments,
          length = 15,
          trimmedString = comment.substring(0, length),
          workday_comment = trimmedString.length > 15
                            ? trimmedString + "..."
                            : trimmedString;
    }
    var empPhoneNumbers = workday.wdy_emp_phone_numbers,
        trimmedPhoneNumber = empPhoneNumbers.substring(0, 12);
        empPhoneNumbers = empPhoneNumbers.length > 12
                          ? trimmedPhoneNumber + "..."
                          : trimmedPhoneNumber;
    var certifyDate = workday.wdy_certify_date,
        formatCertifyDate = new Date(certifyDate);
        formatCertifyDate = formatCertifyDate.getMonth() + 1 + "/" +
                            formatCertifyDate.getDate() + "/" +
                            formatCertifyDate.getFullYear().toString().substr(-2);
      var modalObj = {
          workdayId:workday.id,
          certifyStatus:workday.wdy_certify_status,
          empId:workday.demp_display_Id,
          workdayDate:workday.wdy_date,
          modalName:"Certified_Modal",
          dutyActivityStatus:workday.dutyActivityStatus
      }
    return (
      <tr>
        <td data-title="Division">{workday.division ? workday.division : '-'}</td>
        <td data-title="Employee ID" className="text-center">
          <a className="popUpLink" onClick={() => this.showModal(modalObj)}>
              {workday.demp_display_Id}
          </a>
        </td>
        <td data-title="Job" className="text-center">{workday.job_class}</td>
        <td data-title="First Name" className="text-center"> {first_name} </td>
        <td data-title="Last Name" className="text-center"> {last_name} </td>
        <td data-title="Service Date" className="text-center"> {workday.wdy_date} </td>
        <td data-title="Phone" className="text-center"> 
         <span title={workday.wdy_emp_phone_numbers}>{empPhoneNumbers}</span>
          </td>
        <td data-title="HOS" className="text-center">
          {workday.wdy_working_time_hos_adjust ? (
            workday.wdy_working_time_hos_adjust
          ) : (workday.wdy_working_time_hos)}
        </td>
      <td data-title="TOS" className="text-center">
          {workday.wdy_spread_adjust ? (
            workday.wdy_spread_adjust
          ) : (workday.wdy_spread)}
        </td>
        <td data-title="Certify" className="text-center"> {formatCertifyDate}</td>
        <td data-title="Comments" className="text-center">
         <span title={!workday.wdy_comments || workday.wdy_comments == "NULL" ? "No comments" : comments}>
          {!workday.wdy_comments || workday.wdy_comments == "NULL" ? "-" : workday_comment}
          </span>
        </td>
 
      </tr>
    );
  }
}

function mapStateToProps(state) {
  return {
    workdays: state.workdays.workdays,
    pageNum: state.workdays.pageNum
  };
}

function matchDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      fetchWorkdays: fetchWorkdays,
      onShowModal: showModalAction,
      getWorkday: getWorkdayAction
    },
    dispatch
  );
}

export default connect(mapStateToProps, matchDispatchToProps)(
  CertifiedEmployeesWorkday
);
